import { CONTROLLER, METHOD } from 'common/config/endpoint.config';
import { ApiMethods } from 'common/enums/api-methods.enum';
import { ApiConfig } from 'common/models';
import { PagedRequest } from 'common/models/data/pagedRequest.model';

const syncHistoryConfig = {
    getSyncHistoryUrl: (pagedRequest: PagedRequest): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.FILE_UPLOAD}/${METHOD.FILE_UPLOAD.GET_SYNC_LOGS}`,
            ApiMethods.POST,
            '',
            pagedRequest
        )
};

export default syncHistoryConfig;
